export default {
  personnePhysique: {
    creation: {
      title: 'Création de personne physique',
    },
    'creation-masse': {
      title: 'Création en masse de personnes physiques',
    },
    remplacerContact: {
      title: 'Remplacer contact',
      done: 'Le contact a été remplacé dans les instances',
    },
    detail: {
      title: 'Personne physique',
      form: {
        contact: {
          id: 'ID',
          raisonSociale: 'Personne morale',
          nomUsuel: 'Nom de la société',
          titre: 'Titre',
          typeContact: 'Type de contact (MDL)',
          titreContact: 'Titre',
          fonction: 'Fonction',
          acces: 'Accès autorisés',
          collaborateurMDL: 'Collaborateur MDL',
          remplacant: 'Contact en cas d\'absence',
          lait: 'Lait produit',
          mail: 'Adresse mail',
          service: 'Direction / Service',
          fax: 'Fax',
          smsAccepte: 'Accepte SMS',
          principal: 'Contact principal',
          dateLimiteValidite: 'Date limite de validité',
          moyenContactPrefere: 'Moyen contact préféré',
          instances: {
            title: 'Instances de ce contact',
            search: {
              nomInstance: 'Filtrer par nom d\'instance',
            },
            headers: {
              nomInstance: 'Instance',
              typeInstance: 'Type d\'instance',
              typeParticipant: 'Rôle',
            },
          },
        },
        panel: {
          contact: 'Contact',
          acces: 'Acces',
        },
        acces: 'Acces application',
        accesAgil: 'Acces Agil',
        identifiant: {
          title: 'Identifiant',
          tooltip: 'Identifiant de connexion',
        },
        id: 'ID',
        nom: 'Nom',
        prenoms: 'Prénom',
        civilite: 'Civilité',
        telephone: 'Téléphone',
        mailPrincipal: 'Adresse mail',
        typeParticipant: 'Type de participant',
      },
    },
  },
};
